export const BASE_URL: string = 'http://196.189.124.250:5001/api';

export const getImageUrl = (path: string): string => {
	return `http://196.189.124.250:5001/${path}`;
};
